import { InjectionToken } from '@angular/core';

export const GOOGLE_MAPS_API_CONFIG_TOKEN = new InjectionToken<ApiConfig>('config');

export interface ApiConfig {
  apiKey: string;
}
